import React from "react";
import { Tooltip } from "antd";

import BadgeWhite from "../assets/images/badge_white.png";
import BadgeBronze from "../assets/images/badge_bronze.png";
import BadgeSilver from "../assets/images/badge_silver.png";
import BadgeGold from "../assets/images/badge_gold.png";
import BadgePink from "../assets/images/badge_pink.png";
import BadgePurple from "../assets/images/badge_purple.png";
import BadgeRainbow from "../assets/images/badge_rainbow.png";

const Badge = ({ rank }) => {
    const rankStyles = {
        width: "25x",
        height: "25px",
    };

    const renderrank = (rank) => {
        switch (rank) {
            case 0:
                return null;
            case 1:
                return (
                    <Tooltip title="Stylish">
                        <img src={BadgeWhite} style={rankStyles} alt="" />
                    </Tooltip>
                );
            case 2:
                return (
                    <Tooltip title="Stylish">
                        <img src={BadgeBronze} style={rankStyles} alt="" />
                    </Tooltip>
                );
            case 3:
                return (
                    <Tooltip title="Stylish">
                        <img src={BadgeSilver} style={rankStyles} alt="" />
                    </Tooltip>
                );
            case 4:
                return (
                    <Tooltip title="Graceful">
                        <img src={BadgeGold} style={rankStyles} alt="" />
                    </Tooltip>
                );
            case 5:
                return (
                    <Tooltip title="Graceful">
                        <img src={BadgePink} style={rankStyles} alt="" />
                    </Tooltip>
                );
            case 6:
                return (
                    <Tooltip title="Graceful">
                        <img src={BadgePurple} style={rankStyles} alt="" />
                    </Tooltip>
                );
            case 7:
                return (
                    <Tooltip title="Top Class">
                        <img src={BadgeRainbow} style={rankStyles} alt="" />
                    </Tooltip>
                );
            default:
                return null;
        }
    };

    return renderrank(rank);
};

export default Badge;
